/**
 * Main
 *
 * The main file, page logic which is needed on all pages will be included here.
 * Please note for specific components like a slider create a separated components/<component_name>.js
 * The components will be loaded through the component loader and are not needed on every page!
 */
import MmenuLight from 'mmenu-light';
document.addEventListener('DOMContentLoaded', function () {
  $('.js-search-toggle').on('click', function (event) {
    event.preventDefault();
    event.stopPropagation();
    $('.header__search').toggleClass('is-active');
  });
  $(document).on('click', function (event) {
    if (!$(event.target).closest('.header__search').length) {
      $('.header__search').removeClass('is-active');
    }

    if (!$(event.target).closest('.header__categories-holder').length) {
      $('.header__categories').removeClass('is-active');
      $('.wrapper').removeClass('is-active');
    }
  });
  $('.js-category-toggle').on('click', function (event) {
    event.preventDefault();
    event.stopPropagation();
    $(this).parent().toggleClass('is-active');
    $('.wrapper').toggleClass('is-active');
  });
  var menuHolder = document.querySelector('#nav');

  if (menuHolder) {
    var menu = new MmenuLight(menuHolder, '(max-width: 740px)');
    menu.navigation({
      selected: 'is-active',
      title: 'Menu',
      theme: 'dark'
    });
    var drawer = menu.offcanvas({
      position: 'right'
    });
    document.querySelector('a[href="#nav"]').addEventListener('click', function (event) {
      event.preventDefault();
      drawer.open();
    });
  }

  $('.woocommerce').on('change', 'input.qty', function () {
    $('[name=\'update_cart\']').trigger('click');
  });
});